import React, { FC, MutableRefObject, useRef } from "react";
import { useDispatcher } from "@hooks";
import { IDispatcher } from '@dirootie-web/elements-types';
type PageFormContentProps = {} & any;
type IAction ={ } & any;

const createOnActionClick = (
  dispatch: (action: IAction) => void,
  formikFormRef: MutableRefObject<null>
) => {
  const onActionClick = (ev: any, action: IAction) => {
    if (action.action === "save" || action.action === "create") {
      (formikFormRef.current as any).submitForm();
    } else {
      dispatch(action);
    }
  };
  return onActionClick;
};

export const withFormik = (WrappedComponent: FC<any>) => {
  const WithFormik = (props: PageFormContentProps) => {
    const [dispatch,_] = useDispatcher();
    const formRef = useRef(null);
    const {
      form,
      toolbar: { onActionClick, ...restToolbar },
      ...rest
    } = props;
    const resultProps = {
      toolbar: {
        onActionClick: createOnActionClick(dispatch, formRef),
        ...restToolbar,
      },
      form: { ...props.form, formikFormRef: formRef },
      ...rest,
    };
    return <WrappedComponent {...resultProps} />;
  };

  WithFormik.displayName = `withFormik(${
    WrappedComponent.displayName || WrappedComponent.name
  })`;
  return WithFormik;
};
